<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('gameSet.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('gameSet.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex ts-justify-end">
          <!-- <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button> -->
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('gameSet.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
      >
        <template v-slot="{ record }">
          <td>{{ record.game_set_name }}</td>
          <td>{{ record.game_setting.game_setting }}</td>
          <td>{{ record.jackpot }}</td>
          <td>{{ record.result_date }}</td>
          <td>{{ record.close_time }}</td>
          <td>{{ record.status }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- show form create -->
    <a-modal
      v-if="show_frm_create_or_update"
      v-model="show_frm_create_or_update"
      :title="isEdit ? $t('update') : $t('create')"
      centered
      :footer="null"
      :zIndex="1020"
      :mask-closable="false"
      @cancel="onClose"
    >
      <form-create-update @close="onClose" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

import FormCreateUpdate from './components/frm_create_update'
export default {
  name: 'gameSetIndex',
  components: {
    FormCreateUpdate
  },
  data() {
    return {
      loading: false,
      show_frm_create_or_update: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/gameSet', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.gameSet.search
      },
      set(newValue) {
        this.$store.commit('administrator/gameSet/SET_SEARCH', newValue)
        this.$store.commit('administrator/gameSet/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('gameSet.gameSetName') },
        { name: this.$t('gameSet.gameSettingName') },
        { name: this.$t('gameSet.jackpot') },
        { name: this.$t('gameSet.resultDate') },
        { name: this.$t('gameSet.closeTime') },
        { name: this.$t('gameSet.status') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    },
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.gameSet.edit_data)
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/gameSet/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.show_frm_create_or_update = true
    },
    onClose() {
      this.show_frm_create_or_update = false
      this.fetchData()
      this.$store.commit('administrator/gameSet/SET_EDIT_DATA', {})
    },
    edit(record) {
      this.$store.commit('administrator/gameSet/SET_EDIT_DATA', record)
      this.show_frm_create_or_update = true
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/gameSet/RESET_STATE')
    next()
  }
}
</script>
